import React from "react";
import { Helmet } from "react-helmet";
// Screens
import Landing from "./screens/Landing.jsx";
import { FloatingWhatsApp } from 'react-floating-whatsapp'
export default function App() {
  return (
    <>
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link href="https://fonts.googleapis.com/css2?family=Khula:wght@400;600;800&display=swap" rel="stylesheet" />
      </Helmet>
      <Landing />
      <FloatingWhatsApp
        phoneNumber="+91 6303435214"
        accountName="Nlite Interiors"
        allowEsc
        allowClickAway
        notification
        notificationSound
      />
    </>
  );
}

